export interface IScopeVariable {
  name: string;
  value: string | boolean | number;
}

export enum VariableType {
  number = 'Number',
  string = 'String',
  boolean = 'Boolean',
  dataSet = 'Data Set',
}

// indicates from where/by what the variable was set/updated last time
export enum VariableSource {
  URLParam = 'url',
  Action = 'action',
  Bookmark = 'bookmark',
  Object = 'object',
}

export interface IWorkbookVariableScope {
  id: string;
  scopeDefaultValue: IScopeVariable | undefined;
}

export interface IWorkbookVariable {
  id: string;
  revision: number;
  scopeId: string;
  name: string;
  value: VariableValue;
  defaultValue?: VariableValue;
  type: VariableType;
  subtype?: string;
  excludeFromBookmarks?: boolean;
  created: string;
  updated?: string;
  hasOwnDefault?: boolean;
  isGlobalScope?: boolean;
  scopes?: IWorkbookVariableScope[];
  source?: VariableSource;
}

export type IWorkbookVariableBatchChange =
  | { kind: 'create'; variable: ICreateWorkbookVariable }
  | { kind: 'update'; variableId: string; expectedRevision: number; variable: ICreateWorkbookVariable }
  | { kind: 'remove'; variableId: string; expectedRevision: number };

export interface IWorkbookVariableBatchChangeResult {
  created: IWorkbookVariable[];
  updated: IWorkbookVariable[];
  removedIds: string[];
}

export interface IUpdateWorkbookVariable {
  name?: string;
  value?: VariableValue;
  defaultValue?: VariableValue;
  type?: VariableType;
  subtype?: string;
  excludeFromBookmarks?: boolean;
  source?: VariableSource;
}

export interface ICreateWorkbookVariable {
  name: string;
  value: VariableValue;
  type: VariableType;
  subtype?: string;
  excludeFromBookmarks?: boolean;
  source?: VariableSource;
}

export type DataSetVariableValue = Record<string, unknown>;

export type VariableValue = boolean | string | number | DataSetVariableValue;
